import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';

import { AuthGuard } from './auth/auth-guard.service';
import { AuthContainer } from './auth/auth.container';
import { SelectivePreloadingStrategyService } from './selective-proloading-strategies.service';
import { StoreRouterConnectingModule } from '@ngrx/router-store';

const appRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: DashboardComponent
    },
    {
        path: 'login',
        component: AuthContainer
    },
    {
        path: 'admin', canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: 'settings', canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
    },
    {
        path: 'clients/:kid/udfoer/regnskabsaar/:regnskabsaarId/sag/:sagid',
        canActivate: [AuthGuard],
        loadChildren: () => import('./clients/sag/sag.module').then(m => m.SagModule),
        data: { preload: true }
    },
    {
        path: 'clients/:kid',
        canActivate: [AuthGuard],
        loadChildren: () => import('./clients/client-details/client-details.module').then(m => m.ClientDetailsModule),
        data: { preload: true }
    },
    {
        path: 'clients',
        canActivate: [AuthGuard],
        loadChildren: () => import('./clients/clients.module').then(m => m.ClientsModule),
        data: { preload: true }
    },
    {
        path: 'checklists',
        canActivate: [AuthGuard],
        loadChildren: () => import('./checklists/checklists.module').then(m => m.ChecklistsModule)
    },
    {
        path: 'print',
        outlet: 'print',
        canActivate: [AuthGuard],
        loadChildren: () => import('./print/print.module').then(m => m.PrintModule),
    },
    {
        path: '**',
        canActivate: [AuthGuard],
        component: DashboardComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {
    onSameUrlNavigation: 'reload',
    preloadingStrategy: SelectivePreloadingStrategyService,
    paramsInheritanceStrategy: 'always'
}
        ),
        StoreRouterConnectingModule.forRoot()
    ],
    exports: [RouterModule, StoreRouterConnectingModule]
})

export class AppRoutingModule {}
